import type { Client } from "../types/api.types";
import type { ApiRawRecord } from "../types/common";

import { crmClientPlatformUserId } from "./crmClientPlatformUserId";

/**
 * Id для связки ATON `user_id` ↔ CRM: в воронке и `AllActivesService` scope — `client.id` (PK).
 */
export function crmClientActivesUserId(client: Client | ApiRawRecord): number | undefined {
    const id = Number((client as ApiRawRecord).id);
    return Number.isFinite(id) && id > 0 ? id : undefined;
}

/** Все id клиента, по которым может прийти строка портфеля (PK + платформенный user). */
export function collectCrmClientActivesMatchIds(client: Client | ApiRawRecord): number[] {
    const out = new Set<number>();
    const pk = crmClientActivesUserId(client);
    if (pk != null) {
        out.add(pk);
    }
    const platform = crmClientPlatformUserId(client);
    if (platform != null) {
        out.add(platform);
    }
    return [...out];
}

export function clientMatchesActivesAllowedIds(
    client: Client | ApiRawRecord,
    allowed: Set<number>
): boolean {
    if (allowed.size === 0) {
        return false;
    }
    return collectCrmClientActivesMatchIds(client).some((id) => allowed.has(id));
}
